import PhoneCallIcon from '@cp/src/assets/icons/PhoneCallIcon';
import { ArrowRightIcon } from '@navi/web-ui/lib/icons';
import { Typography } from '@navi/web-ui/lib/primitives';
import { navigateToCaseDetails } from '@cp/src/utils/commonUtils';
import { createQueryParams } from '@cp/src/utils/QueryParamsHelper';
import { useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { TAB_KEYS } from '../../../constants';
import { useDispatch } from 'react-redux';
import { acknowledgePendingAction, getActivePendingActions } from './actions';
import APP_ROUTES from '@cp/src/layout/Routes';
import styles from '../index.module.scss';
import cx from 'classnames';

type ActionContainerProps = {
  showNotificationDot?: boolean;
  actionReferenceId?: string;
  actionLabel?: string;
};

const ActionContainer = (props: ActionContainerProps) => {
  const { showNotificationDot, actionReferenceId, actionLabel } = props;

  const {
    loanId = '',
    customerId = '',
    caseReferenceId = '',
    caseBusinessVertical = ''
  } = useParams();

  const navigate = useNavigate();
  const actionPopperRef = useRef<HTMLElement>(null);
  const dispatch = useDispatch();

  const handleNavigationToCaseDetails = () => {
    const updatedParams = {
      [TAB_KEYS.CONTACT]: {
        selectedTab: TAB_KEYS.CONTACT
      }
    };

    const url = createQueryParams(updatedParams);
    if (actionPopperRef?.current) {
      //@ts-expect-error this is due to default type define in floating widgets
      actionPopperRef?.current?.context?.setOpen?.(false);
    }
    navigateToCaseDetails(
      customerId,
      loanId,
      caseReferenceId,
      caseBusinessVertical,
      navigate,
      APP_ROUTES.CASE_DETAIL.path,
      url,
      TAB_KEYS.CONTACT
    );
  };

  const handleOnClick = () => {
    if (actionReferenceId === undefined) {
      return;
    }

    acknowledgePendingAction(actionReferenceId)().then(acknowledged => {
      if (acknowledged) {
        dispatch(getActivePendingActions(caseReferenceId, loanId, customerId));
        handleNavigationToCaseDetails();
      }
    });
  };

  return (
    <div
      className={cx(
        'flex opacity-80 rounded-xl p-3 w-auto cursor-pointer',
        styles.gradientBackground
      )}
      onClick={handleOnClick}
    >
      <div className="flex items-center">
        <div className="relative">
          {showNotificationDot ? (
            <div className="absolute w-2 h-2 bg-red-500 rounded-full"></div>
          ) : null}
          <PhoneCallIcon />
        </div>
        <Typography variant="p4" color="var(--navi-color-gray-c2)" className="ml-2 mr-2">
          {actionLabel}
        </Typography>
      </div>
      <ArrowRightIcon className="mt-[2px]" size={'sm'} color={'var(--navi-color-gray-c3)'} />
    </div>
  );
};

export default ActionContainer;
